// PLEASE REMOVE `LOCAL STORAGE` WHEN YOU CHANGE SETTINGS.
// ----------------------------------------------------------------------

export const allLangs = [
  {
    label: 'English',
    value: 'en',
    icon: '/assets/icons/flags/ic_flag_en.svg',
  },
  {
    label: 'Русский',
    value: 'ru',
    icon: '/assets/icons/flags/russian.svg',
  },
  {
    label: 'Türkçe',
    value: 'tr',
    icon: '/assets/icons/flags/turkey.svg',
  },
  {
    label: "O'zbekcha",
    value: 'uz',
    icon: '/assets/icons/flags/uzbekistan.svg',
  },
];

export const defaultLang = allLangs[1]; // Russian
